import routes from 'src/routes'

export default function InvalidInviteLink() {
    return (
        <div className="flex h-full w-full flex-col items-center justify-center space-y-4">
            <p className="m-0 text-2xl">
                Whoops! Looks like the link you used is either broken or expired
            </p>
            <a href={routes.login}>
                <button className="w-36 rounded bg-primary-red-500 px-4 py-3 text-center font-Arial text-12-14 font-medium uppercase text-white">
                    Back to login
                </button>
            </a>
        </div>
    )
}
